module.exports = __webpack_public_path__ + "img/share_arrows@2x.de3d96e7.png";